/* eslint-disable react/no-access-state-in-setstate */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, FormControl, Panel, Row } from 'react-bootstrap';
import ShipmentWebAPIUtils from 'utils/ShipmentWebAPIUtils';
import ExceptionStore from 'stores/ExceptionStore';
import ShipmentsActionCreators from 'actions/ShipmentsActionCreators';
import ShipmentStore from 'stores/ShipmentStore';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import PDFViewer from '../PDFViewer';
import {
  getDocumentsV2,
  getSignedUrl,
} from '../../../../utils/DocumentsAPIUtils';
import { showToast } from '../../../../stores/ToastStore';

class RequestChanges extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      shipment: {},
      signedUrl: null,
    };
  }

  componentDidMount() {
    ShipmentStore.addChangeListener(this.shipmentChange.bind(this));
    ExceptionStore.addChangeListener(this.exceptionChange);
    this.getShipment(this.state.id);
  }

  componentWillUnmount() {
    ShipmentStore.removeChangeListener(this.shipmentChange.bind(this));
    ExceptionStore.removeChangeListener(this.exceptionChange);
  }

  onTextChange = (event) => {
    this.setState({ request_text: event.target.value });
  };

  getShipment = (id) => {
    // This is for carriers.
    const isAdmin = false;
    ShipmentsActionCreators.getShipment(id, isAdmin);
  };

  shipmentChange = async () => {
    const { t } = this.props;
    const shipment = ShipmentStore.getShipment(this.state.id);

    const { data, errors: documentErrors } = await getDocumentsV2(
      [shipment._id],
      'delivery_order',
      {
        order: {
          field: 'createdAt',
          direction: 'desc',
        },
        limit: 1,
      },
    );

    if (documentErrors) {
      showToast(
        t('GET_DOCUMENT_ERROR'),
        t('GET_DOCUMENT_FAILED_WITH_ERROR', {
          error: documentErrors[0].message,
        }),
        'error',
      );
      return;
    }

    if (data?.getDocumentsV2?.documents?.length > 0) {
      const { data: signedUrlData, errors: signedUrlErrors } =
        await getSignedUrl(data.getDocumentsV2.documents[0].key);

      if (signedUrlErrors) {
        showToast(
          t('GET_DOCUMENT_ERROR'),
          t('GET_DOCUMENT_FAILED_WITH_ERROR', {
            error: signedUrlErrors[0].message,
          }),
          'error',
        );
        return;
      }

      if (signedUrlData?.getSignedUrl?.signedUrl) {
        const signedUrl = signedUrlData?.getSignedUrl.signedUrl;
        this.setState({ shipment, signedUrl });
      }
    }

    this.setState({ shipment });
  };

  exceptionChange = () => {
    // If there was an error creating the exception, don't do anything.
    // If it succeeded, redirect to the shipments page.
    if (!ExceptionStore.getCreationError()) {
      // Allow time for the success toast to display.
      setTimeout(() => {
        window.location.href = '/shipments';
      }, 3000);
    }
  };

  handleSubmit = async () => {
    const {
      request_text,
      shipment: { _id },
    } = this.state;

    const statusUpdate = {
      message: request_text,
      status: 'change_request',
    };
    const result = await ShipmentWebAPIUtils.updateChangeException(
      _id,
      statusUpdate,
    );
    if (result) {
      setTimeout(() => {
        window.location.href = '/shipments';
      }, 3000);
    }
  };

  renderChangeRequest(shipment) {
    return (
      <div>
        <Row>
          <h2>
            {this.props.t('SUBMIT_DELIVERY_CHANGE_REQUEST', {
              shipmentId: shipment.shipment_id,
            })}
          </h2>
        </Row>
        <Row className="py-8">
          <FormControl
            componentClass="textarea"
            rows={5}
            placeholder={this.props.t('ENTER_REQUESTED_CHANGES')}
            value={this.state.request_text}
            onChange={this.onTextChange}
          />
        </Row>
        <Row>
          <Col>
            <Button
              className="pull-right"
              bsStyle="success"
              style={{ marginTop: 10 + 'px' }}
              onClick={this.handleSubmit}
            >
              {titleize(this.props.t('SUBMIT'))}
            </Button>
          </Col>
        </Row>
      </div>
    );
  }

  renderDeliveryOrderPdf() {
    if (this.state.signedUrl) {
      return (
        <Row>
          <PDFViewer file={this.state.signedUrl} />
        </Row>
      );
    }
    return (
      <Row>
        <span>{this.props.t('WAITING_FOR_PDF')}</span>
      </Row>
    );
  }

  render() {
    const shipment = this.state.shipment;

    return (
      shipment && (
        <Panel>
          <div>
            <Col xs={6}>{this.renderChangeRequest(shipment)}</Col>
            <Col xs={6}>{this.renderDeliveryOrderPdf()}</Col>
          </div>
        </Panel>
      )
    );
  }
}

RequestChanges.propTypes = {
  match: PropTypes.object.isRequired,
};

export default withTranslation()(RequestChanges);
